import store from 'config/configureStore';
import { handleError } from './ErrorReducer';
import { getService } from './service';

const dbSettingsStore = [
  // saved in DB
  'mapSettings',
  'incidentFilter',
  'lastCourtDetails',
  'evidencePreferenceSetting',
];

export const defaultState = {
  mapSettings: {
    mapZoom: 11,
    mapLat: 30.442053893783818,
    mapLng: -91.1995323879929,
    mapTypeId: 'roadmap', // roadmap, satellite, hybrid, terrain
  },
};

const settingsKey = 'RMS';

const localSettingsStore = ['logE911Events']; // saved in local storage

export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';

const loadDBSettings = async (ptsUserID, dispatch) => {
  const service = getService('user-settings');
  let data = {};
  try {
    const unitGroups = await service.find({
      query: {
        ptsUserID: ptsUserID,
        ApplicationName: settingsKey,
        IsDeleted: false,
      },
    });
    if (unitGroups.data.length > 0) data = JSON.parse(unitGroups.data[0].JsonValue);
  } catch (err) {
    dispatch(handleError(err));
  }
  return data;
};

export const loadUserSettings = () => async (dispatch) => {
  const state = store.store.getState();
  const ptsUserID = state?.user?.userData?.user?.ptsUserID;
  if (!ptsUserID) return dispatch(handleError('Error loading user settings.'));
  // 1. Load local storage settings
  let localUserSettings = {};
  const localSettingsStr = window.localStorage.getItem(settingsKey);
  const localSettings = localSettingsStr ? JSON.parse(localSettingsStr) : {};
  if (localSettingsStr) {
    const userSettings = localSettings[ptsUserID];
    const filteredUserSettings = {};
    // filter user settings only present in localSettingsStore
    localSettingsStore.forEach((key) => {
      if (userSettings[key]) filteredUserSettings[key] = userSettings[key];
    });
    if (userSettings) localUserSettings = filteredUserSettings;
  }
  // 2. Load DB settings
  const dbUserSettings = await loadDBSettings(ptsUserID, dispatch);
  // 3. Concat settings and update redux
  const currentSettings = state.userSettings;
  const userSettings = {
    ...currentSettings,
    ...localUserSettings,
    ...dbUserSettings,
    loaded: true,
  };
  dispatch({ type: SET_USER_SETTINGS, userSettings });
};

// eslint-disable-next-line unused-imports/no-unused-vars
const saveDBSettings = async (ptsUserID, data, dispatch) => {
  const dataStr = JSON.stringify(data);
  const service = getService('user-settings');
  try {
    const exist = await service.find({
      query: {
        ptsUserID: ptsUserID,
        ApplicationName: settingsKey,
        IsDeleted: false,
      },
    });
    if (exist?.data.length === 0) {
      await service.create({
        ptsUserID,
        ApplicationName: settingsKey,
        JsonValue: dataStr,
      });
    } else {
      await service.patch(exist.data[0].ptsUserSettingID, {
        JsonValue: dataStr,
      });
    }
  } catch (err) {
    // dispatch(handleError(err));
    console.log(err);
  }
};

export const saveUserSetting = (name, value) => async (dispatch) => {
  const state = store.store.getState();
  const ptsUserID = state?.user?.userData?.user?.ptsUserID;
  const currentValue = state.userSettings[name];
  if (currentValue === value) return;
  if (!ptsUserID) return dispatch(handleError('Error saving user settings.'));
  const userSettings = { ...state.userSettings, [name]: value };
  // 1. Save in reducer
  dispatch({ type: SET_USER_SETTINGS, userSettings });
  // 2. Save in the DB
  if (dbSettingsStore.indexOf(name) !== -1) {
    const dbUserSettings = {};
    dbSettingsStore.forEach((key) => {
      dbUserSettings[key] = userSettings[key];
    });
    await saveDBSettings(ptsUserID, dbUserSettings, dispatch);
  }
  //   3. Save in local storage
  else if (localSettingsStore.indexOf(name) !== -1) {
    const localSettingsStr = window.localStorage.getItem(settingsKey);
    const localSettings = localSettingsStr ? JSON.parse(localSettingsStr) : {};
    const userLocalSettings = { ...userSettings };
    Object.keys(userSettings).forEach((key) => {
      if (localSettingsStore.indexOf(key) === -1) delete userLocalSettings[key];
    });
    const saveLocalSettings = JSON.stringify({ ...localSettings, [ptsUserID]: userLocalSettings });
    window.localStorage.setItem(settingsKey, saveLocalSettings);
  }
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_USER_SETTINGS:
      return action.userSettings;
    // case RESET_USER_SETTINGS:
    //   return defaultUserSettings;
    default:
      return state;
  }
}
